import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import SurveyJSFormRenderer from '@unite-us/surveyjs/dist/components/Renderer/SurveyJSFormRenderer';
import buildResponses from '@unite-us/surveyjs/dist/components/Renderer/buildResponses';
import Spinner from '../../common/spinners/Spinner';
import { PrimaryButton, SecondaryButton } from '../../common/TailwindComponents';
import useFormSubmissions from '../hooks/useFormSubmissions';
import { EnrollmentsSupportingDocuments } from './EnrollmentsSupportingDocuments';
import './EnrollmentApplication.scss';
export var EnrollmentApplication = function EnrollmentApplication(_ref) {
  var _plan$metafields;
  var contactId = _ref.contactId,
    currentEmployee = _ref.currentEmployee,
    form = _ref.form,
    formResponse = _ref.formResponse,
    groupId = _ref.groupId,
    handleAttachDocuments = _ref.handleAttachDocuments,
    handleFormResponseChange = _ref.handleFormResponseChange,
    plan = _ref.plan,
    stepBackward = _ref.stepBackward,
    stepForward = _ref.stepForward;
  var surveyRef = useRef();
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    submitTriggered = _useState2[0],
    setSubmitTriggered = _useState2[1];
  var metafields = (_plan$metafields = plan === null || plan === void 0 ? void 0 : plan.metafields) !== null && _plan$metafields !== void 0 ? _plan$metafields : [];
  var metaFieldFiles = _filterInstanceProperty(metafields).call(metafields, function (_ref2) {
    var type = _ref2.type;
    return type === 'file';
  });
  var handleSetSurvey = function handleSetSurvey(survey) {
    surveyRef.current = survey;
  };
  var submitDocuments = function submitDocuments(data) {
    handleAttachDocuments(get(data, 'metadata'));
    stepForward();
  };
  var handleOnSubmit = function handleOnSubmit() {
    var survey = surveyRef.current;
    if (survey.completeLastPage() && !survey.hasErrors()) {
      handleFormResponseChange(buildResponses(survey));
      if (!isEmpty(metaFieldFiles)) {
        setSubmitTriggered(submitTriggered + 1);
      } else {
        stepForward();
      }
    }
  };
  var contextType = 'person';
  var context = contactId;
  var formSubmissionsData = useFormSubmissions({
    contextType: contextType,
    context: context,
    providerId: groupId,
    formFilter: form.id
  });
  var formSubmission;
  if (isEmpty(formResponse)) {
    formSubmission = get(formSubmissionsData, 'formSubmissions[0]');
  } else {
    formSubmission = {
      responses: formResponse,
      form: form.id,
      provider: groupId,
      contextType: 'person',
      context: contactId,
      submitter: currentEmployee
    };
  }
  if (isEmpty(form)) {
    return /*#__PURE__*/React.createElement("div", {
      className: "form--loading"
    }, /*#__PURE__*/React.createElement(Spinner, null));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "p-4 pt-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-white px-6 py-4 flex items-center justify-start space-x-6"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SurveyJSFormRenderer, {
    formData: {
      configuration: form === null || form === void 0 ? void 0 : form.configuration
    },
    formSubmission: formSubmission,
    editMode: true,
    handleSetSurveyModel: handleSetSurvey
  }), /*#__PURE__*/React.createElement("div", {
    className: "relative z-0"
  }, !isEmpty(metaFieldFiles) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "border-t border-solid border-med-pale-blue -mx-2 lg:-mx-8 xl:-mx-16 mt-4 mb-10"
  }), /*#__PURE__*/React.createElement("h3", {
    className: "text-lg text-dark-blue font-medium-font mb-4 leading-7"
  }, "Supporting Documents"), /*#__PURE__*/React.createElement("p", {
    className: "mb-10 text-13px"
  }, "Upload your documents from your device. Acceptable formats are .CSV, .DOCX, .PDF, .JPG, or .PNG"), /*#__PURE__*/React.createElement("div", {
    className: "space-y-8"
  }, /*#__PURE__*/React.createElement(EnrollmentsSupportingDocuments, {
    metaFieldFiles: metaFieldFiles,
    submitTriggered: submitTriggered,
    onSubmit: function onSubmit(data) {
      return submitDocuments(data);
    }
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-end px-6 py-4 space-x-6"
  }, /*#__PURE__*/React.createElement(SecondaryButton, {
    label: "Previous",
    "data-testid": "supporting-docs-previous-button",
    onClick: stepBackward
  }), /*#__PURE__*/React.createElement(PrimaryButton, {
    label: "Next",
    "data-testid": "supporting-docs-next-button",
    type: "submit",
    onClick: handleOnSubmit
  })));
};
EnrollmentApplication.propTypes = {
  plan: PropTypes.object.isRequired,
  groupId: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
  formResponse: PropTypes.array.isRequired,
  currentEmployee: PropTypes.string.isRequired,
  contactId: PropTypes.string.isRequired,
  handleFormResponseChange: PropTypes.func.isRequired,
  handleAttachDocuments: PropTypes.func.isRequired,
  stepForward: PropTypes.func.isRequired,
  stepBackward: PropTypes.func.isRequired
};
//# sourceMappingURL=EnrollmentApplication.js.map